// extracted by mini-css-extract-plugin
export default {"Container":"CounterBookmark_Container__xD6xR","showDiv":"CounterBookmark_showDiv__aSD6-"};